import React from 'react';
import { MapPin, Phone, Clock, Mail } from 'lucide-react';

const Location = () => {
  return (
    <section id="location" className="section-padding bg-[var(--bg-primary)]">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="heading-1 mb-4">Localização e Contato</h2>
          <p className="body-regular text-[var(--text-secondary)]">
            Estamos em Sorocaba - SP, prontos para atender você
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-8">
            <div>
              <h3 className="heading-3 mb-6">Entre em contato</h3>
              
              {/* Address */}
              <div className="flex gap-4 mb-6">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-[var(--accent-gold)] rounded-full flex items-center justify-center text-white">
                    <MapPin size={24} />
                  </div>
                </div>
                <div>
                  <h4 className="font-semibold text-[var(--text-primary)] mb-1">Endereço</h4>
                  <p className="body-regular text-[var(--text-secondary)]">
                    R. Dr. Américo Figueiredo, 4980<br />
                    Santa Bárbara - Sorocaba - SP
                  </p>
                  <a
                    href="https://www.google.com/maps/dir//R.+Dr.+Am%C3%A9rico+Figueiredo,+4980+-+Santa+B%C3%A1rbara,+Sorocaba+-+SP"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[var(--accent-gold)] hover:underline text-sm mt-2 inline-block"
                  >
                    Ver no Google Maps →
                  </a>
                </div>
              </div>

              {/* Phone */}
              <div className="flex gap-4 mb-6">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-[var(--accent-gold)] rounded-full flex items-center justify-center text-white">
                    <Phone size={24} />
                  </div>
                </div>
                <div>
                  <h4 className="font-semibold text-[var(--text-primary)] mb-1">WhatsApp</h4>
                  <a
                    href="https://wa.me/5515991253527"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="body-regular text-[var(--text-secondary)] hover:text-[var(--accent-gold)] transition-colors"
                  >
                    (15) 99125-3527
                  </a>
                </div>
              </div>

              {/* Hours */}
              <div className="flex gap-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-[var(--accent-gold)] rounded-full flex items-center justify-center text-white">
                    <Clock size={24} />
                  </div>
                </div>
                <div>
                  <h4 className="font-semibold text-[var(--text-primary)] mb-1">Horário de Atendimento</h4>
                  <p className="body-regular text-[var(--text-secondary)]">
                    Segunda a Sexta: 9h - 17h
                  </p>
                </div>
              </div>
            </div>

            {/* CTA Box */}
            <div className="bg-[var(--bg-secondary)] p-8 mt-8">
              <h3 className="heading-3 mb-4">Solicite seu orçamento</h3>
              <p className="body-regular text-[var(--text-secondary)] mb-6">
                Entre em contato via WhatsApp e receba atendimento personalizado. Visita técnica sem compromisso!
              </p>
              <a
                href="https://wa.me/5515991253527?text=Olá!%20Gostaria%20de%20solicitar%20um%20orçamento."
                target="_blank"
                rel="noopener noreferrer"
                className="btn-gold w-full sm:w-auto"
              >
                Falar no WhatsApp
              </a>
            </div>
          </div>

          {/* Google Maps */}
          <div className="h-[500px] rounded-sm overflow-hidden shadow-lg hover-lift">
            <iframe
              src="https://www.google.com/maps?q=R.+Dr.+Am%C3%A9rico+Figueiredo,+4980+-+Santa+B%C3%A1rbara,+Sorocaba+-+SP&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização Forti Vidros"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
